export default function Contact() {
    return (
        <div className="Contact">
            <h2>Contactez-nous</h2>
            <p>Formulaire de contact a venir</p>
        </div>
    );
}